module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/academy/adriti@1x.svg"